import "./OrdersToolbar.css";

import {
  MdSearch,
  MdFilterAlt,
  MdRefresh,
} from "react-icons/md";

function OrdersToolbar({
  search,
  setSearch,
  status,
  setStatus,
  refreshOrders,
}) {
  return (
    <div className="orders-toolbar">

      <div className="toolbar-search">

        <MdSearch />

        <input
          type="text"
          placeholder="Search customer, food or order..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

      </div>

      <div className="toolbar-actions">

        <div className="toolbar-filter">

          <MdFilterAlt />

          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="">All Status</option>
            <option value="Pending">Pending</option>
            <option value="Accepted">Accepted</option>
            <option value="Preparing">Preparing</option>
            <option value="Out For Delivery">
              Out For Delivery
            </option>
            <option value="Delivered">
              Delivered
            </option>
            <option value="Rejected">
              Rejected
            </option>
          </select>

        </div>

        <button
          className="toolbar-refresh"
          onClick={refreshOrders}
        >
          <MdRefresh />
          Refresh
        </button>

      </div>

    </div>
  );
}

export default OrdersToolbar;